// assets/filter-collection.js
(() => {
  let sectionType = "search";
  const isCollectionsPath = /^\/collections(\/|$)/i.test(location.pathname);
  if (isCollectionsPath) sectionType = "main-collection";

  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const getForms = () => qsa("[data-filters-form]");

  const closeAllFilterGroups = (except = null) => {
    qsa(".filter-group.open").forEach((g) => {
      if (g === except) return;
      g.classList.remove("open");
      g.querySelector("[data-filter-toggle]")?.setAttribute(
        "aria-expanded",
        "false"
      );
      g.querySelector(".filter-group__options")?.setAttribute(
        "aria-hidden",
        "true"
      );
    });
  };

  const closeAllSortGroups = (except = null) => {
    qsa(".sort-group.open").forEach((g) => {
      if (g === except) return;
      g.classList.remove("open");
      g.querySelector("[data-sort-toggle]")?.setAttribute(
        "aria-expanded",
        "false"
      );
      g.querySelector("[data-sort-options]")?.setAttribute(
        "aria-hidden",
        "true"
      );
    });
  };

  const getCheckedFilters = () =>
    qsa('[data-filters-form] input[type="checkbox"]:checked').map((cb) => ({
      name: cb.name.endsWith("[]") ? cb.name.slice(0, -2) : cb.name,
      value: cb.value,
    }));

  const getSortValue = () => {
    // prefer any explicit sort_by hidden input; they should be in sync
    const inp = document.querySelector(
      '[data-filters-form] input[name="sort_by"]'
    );
    return inp ? inp.value : "";
  };

  const setSortValueEverywhere = (value) => {
    getForms().forEach((form) => {
      const inp = form.querySelector('input[name="sort_by"]');
      if (inp) inp.value = value;
    });
  };

  const mirrorCheckboxes = (name, value, checked) => {
    qsa(
      `[data-filters-form] input[type="checkbox"][name="${CSS.escape(
        name
      )}"][value="${CSS.escape(value)}"]`
    ).forEach((el) => {
      el.checked = checked;
    });
  };

  const buildQueryParams = (page = 1) => {
    const params = new URLSearchParams();

    // filters
    const pairs = getCheckedFilters();
    pairs.forEach(({ name, value }) => params.append(name, value));

    // sort
    const sortVal = getSortValue();
    if (sortVal) params.append("sort_by", sortVal);

    // page
    params.append("page", String(page));

    return params;
  };

  // 1) Clear filters
  document.addEventListener("click", (e) => {
    const clearBtn = e.target.closest("[data-clear-filters]");
    if (!clearBtn) return;

    e.preventDefault();
    qsa('[data-filters-form] input[type="checkbox"]').forEach(
      (cb) => (cb.checked = false)
    );
    applyFilters(1, false);
  });

  // 2) Filter dropdown toggle
  document.addEventListener("click", (e) => {
    const filterToggle = e.target.closest("[data-filter-toggle]");
    if (filterToggle) {
      const group = filterToggle.closest("[data-filter-group]");

      closeAllFilterGroups(group);
      closeAllSortGroups();

      const isOpen = group.classList.toggle("open");
      filterToggle.setAttribute("aria-expanded", String(isOpen));
      group
        .querySelector(".filter-group__options")
        ?.setAttribute("aria-hidden", String(!isOpen));
      return;
    }
    if (!e.target.closest("[data-filter-group]")) {
      qsa(".filter-group.open").forEach((g) => {
        g.classList.remove("open");
        g.querySelector("[data-filter-toggle]")?.setAttribute(
          "aria-expanded",
          "false"
        );
        g.querySelector(".filter-group__options")?.setAttribute(
          "aria-hidden",
          "true"
        );
      });
    }
  });

  // 3) Sort dropdown toggle
  document.addEventListener("click", (e) => {
    const sortToggle = e.target.closest("[data-sort-toggle]");
    if (sortToggle) {
      const group = sortToggle.closest("[data-sort-group]");

      closeAllSortGroups(group);
      closeAllFilterGroups();

      const isOpen = group.classList.toggle("open");
      sortToggle.setAttribute("aria-expanded", String(isOpen));
      group
        .querySelector("[data-sort-options]")
        ?.setAttribute("aria-hidden", String(!isOpen));
      return;
    }
    if (!e.target.closest("[data-sort-group]")) {
      qsa(".sort-group.open").forEach((g) => {
        g.classList.remove("open");
        g.querySelector("[data-sort-toggle]")?.setAttribute(
          "aria-expanded",
          "false"
        );
        g.querySelector("[data-sort-options]")?.setAttribute(
          "aria-hidden",
          "true"
        );
      });
    }
  });

  // 4) Sort option selection (sync both UIs)
  document.addEventListener("click", (e) => {    
    const sortOption = e.target.closest(".sort-group__option");
    if (!sortOption) return;

    const value = sortOption.dataset.sortValue || "";
    const label = sortOption.textContent.trim();

    // Update hidden inputs + labels everywhere
    setSortValueEverywhere(value);
    // if (label) setSortLabelEverywhere(label);

    // Close all sort dropdowns
    qsa(".sort-group.open").forEach((g) => {
      g.classList.remove("open");
      g.querySelector("[data-sort-toggle]")?.setAttribute(
        "aria-expanded",
        "false"
      );
      g.querySelector("[data-sort-options]")?.setAttribute(
        "aria-hidden",
        "true"
      );
    });

    applyFilters(1, false);
  });

  // 5) Prevent native submit
  document.addEventListener("submit", (e) => {
    if (!e.target.matches("[data-filters-form]")) return;
    e.preventDefault();
    applyFilters(1, false);
  });

  // 6) Checkbox change → mirror & apply
  document.addEventListener("change", (e) => {
    const cb = e.target;
    if (!cb.matches('[data-filters-form] input[type="checkbox"]')) return;

    // Mirror to the other form(s)
    mirrorCheckboxes(cb.name, cb.value, cb.checked);

    applyFilters(1, false);
  });

  // 7) Load more
  document.addEventListener("click", (e) => {
    const loadBtn = e.target.closest("[data-load-more]");
    if (!loadBtn) return;
    const nextPage = parseInt(loadBtn.dataset.nextPage || "2", 10);
    applyFilters(nextPage, true);
  });

  // 8) Core AJAX + DOM update
  async function applyFilters(page = 1, append = false) {
    let loadMoreInnerText = document.querySelector("[data-load-more]");
    if(loadMoreInnerText)
    {
      loadMoreInnerText = loadMoreInnerText.querySelector('.loadmore-span').textContent;
    }

    let sort_text = document.querySelector('.sort-text')?.textContent;

    console.log('sort_text', sort_text)
    
    const section = document.querySelector(
      `[data-section-type="${sectionType}"]`
    );
    if (!section) return;

    let container;
    let containerId;
    let sectionId;
    let params;
    let base;
    let fetchUrl;
    let qs;
    let json;
    let tmp;
    let incomingRoot;
    let newSection;

    section.classList.add("is-loading");

    if (sectionType == "search") {
      container = section.closest(".shopify-section") || section;
      containerId = container.getAttribute("id") || "";
      sectionId = containerId.startsWith("shopify-section-")
        ? containerId.replace("shopify-section-", "")
        : section.getAttribute("data-section-id") || "search";

      params = buildQueryParams(page) || new URLSearchParams();
      if (!params.get("page")) params.set("page", String(page));

      if (!params.get("q")) {
        // last-ditch: try to read current search term from URL
        const currentQ = new URL(location.href).searchParams.get("q");
        if (currentQ) params.set("q", currentQ);
      }
      if (!params.get("type")) params.set("type", "product");

      base = "/search";
      fetchUrl = `${base}?sections=${encodeURIComponent(sectionId)}${
        params.toString() ? `&${params.toString()}` : ""
      }`;
    } else {
      params = buildQueryParams(page);
      base = window.location.pathname;
      qs = params.toString();
      fetchUrl = `${base}?sections=${sectionType}${qs ? `&${qs}` : ""}`;
    }

    const sortInput = document.querySelector('input[name="sort_by"]');
    if (sortInput && sortInput.value) {
      params.set('sort_by', sortInput.value);
      fetchUrl = fetchUrl + `&${params.toString()}`;
    }


    try {
      const res = await fetch(fetchUrl, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
        credentials: "same-origin",
      });
      if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
      json = await res.json();
    } catch (err) {
      console.error("Filter AJAX error:", err);
      section.classList.remove("is-loading");
      return;
    }

    if (sectionType == "search") {
      const html = json?.[sectionId];
      if (!html) {
        console.warn("[filters] No HTML for section id:", sectionId, json);
        section.classList.remove("is-loading");
        return;
      }
      tmp = document.createElement("div");
      tmp.innerHTML = html;

      // 1) Replace ONLY inner HTML of the section root (preserve attributes/listeners on the node itself)
      if (!append) {
        incomingRoot =
          tmp.querySelector(`#shopify-section-${CSS.escape(sectionId)}`) ||
          tmp.firstElementChild;
        if (incomingRoot) {
          section.innerHTML = incomingRoot.innerHTML;
        }
      }
    } else {
      tmp = document.createElement("div");
      tmp.innerHTML = json[sectionType];

      // Replace ONLY inner content of <section>, preserving attributes
      if (!append) {
        newSection = tmp.querySelector(`[data-section-type="${sectionType}"]`);
        if (newSection) {
          section.innerHTML = newSection.innerHTML;
        }
      }
    }

    // Grid update (append or replace)
    const newGrid = tmp.querySelector("[data-product-grid]");
    const oldGrid = document.querySelector("[data-product-grid]");

    if (newGrid && oldGrid) {
      if (append) {
        oldGrid.insertAdjacentHTML("beforeend", newGrid.innerHTML);
      } else {
        oldGrid.outerHTML = newGrid.outerHTML;
      }
    }

    // Load more
    const newLoadWrap = tmp.querySelector("[data-load-more-container]");
    const oldLoadWrap = document.querySelector("[data-load-more-container]");

    if (newLoadWrap) {
      let newBtn = newLoadWrap.querySelector("[data-load-more]");
      let oldBtn = oldLoadWrap.querySelector("[data-load-more]");
      
      if (append && oldLoadWrap) {        
        if (newBtn && oldBtn) oldBtn.dataset.nextPage = newBtn.dataset.nextPage;
      } else if (!append && oldLoadWrap) {      
        oldLoadWrap.outerHTML = newLoadWrap.outerHTML;
        let newLoadBtn = document.querySelector("[data-load-more]");        
        if(newLoadBtn) {
          newLoadBtn.querySelector('.loadmore-span').textContent =  loadMoreInnerText;         
        }        
      }
    } else if (append && oldLoadWrap) {
      oldLoadWrap.remove();
    }

    if(sort_text) {
      console.log('put sort', sort_text)
      let new_sort = document.querySelectorAll('.sort-text');
      console.log('new sor', new_sort)
      new_sort.forEach((sort) => {
        sort.textContent = sort_text;   
      })
      console.log('new sort', new_sort)
      // new_sort.textContent = sort_text;      
    }

    // URL update on fresh filter/sort
    if (!append) {
      const qs = params.toString();
      const cleanQS = qs.replace(/(^|&)page=\d+(&|$)/, "$1");
      const newUrl = cleanQS ? `${base}?${cleanQS}` : base;
      history.replaceState(null, "", newUrl);
    }

    // Done
    const refreshed = document.querySelector(
      `[data-section-type="${sectionType}"]`
    );
    if (refreshed) refreshed.classList.remove("is-loading");
    addListenerOnAddToCartForm();
  }

  // Event listener for form product
  function addListenerOnAddToCartForm() {
    document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        const formData = new FormData(form);
        const addRes = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" },
        });

        if (!addRes.ok) {
          console.error("Add to cart failed");
          return;
        }

        const added = await addRes.json(); // ← single added line_item

        // 2) Update cart count (entire cart)
        const res = await fetch("/cart.js");
        const cart = await res.json();
        window.updateCartItemCounts(cart.item_count);

        // 3) Update cart drawer (your existing function)
        await window.updateCartDrawer();

        const qtyJustAdded = window.getAddedQuantityFromFormData(formData); // ← 1, or sum of items[n][quantity]

        // 4) Fill cart-notification
        window.fillCartNotification(added, qtyJustAdded);

        // 5) Show notification (your existing function)
        window.openCartNotification();
      });
    });
  }
})();
